import { styled, TextField } from '@mui/material';
import color from 'src/theme/color';

export const SectionSubtitle = {
    font: '12px/15px "Inter",sans-serif',
    color: color.white50,
    marginBottom: '20px'
};

export const DescriptionInput = styled(TextField)({
    width: '100%',
    borderRadius: '8px',
    background: color.blackRock,
    '& .MuiFilledInput-input': {
        color: color.white90,
        fontFamily: '"Inter",sans-serif',
        fontSize: '13px',
        lineHeight: '23px'
    },
    '& .MuiOutlinedInput-root': {
        color: color.white90,
        fontFamily: '"Inter",sans-serif',
        fontSize: '13px',
        lineHeight: '23px',
        '& fieldset': { borderColor: color.yellow60 },
        '&:hover fieldset': { borderColor: color.lightningYellow },
        '&.Mui-focused fieldset': { borderColor: color.lightningYellow }
    }
});

export const startButtonContainerSx = {
    mt: 3,
    display: 'flex',
    justifyContent: 'flex-end'
};

export const startProgressSx = {
    color: color.lightningYellow
};

export const modeSelectSx = {
    minWidth: 220,
    borderRadius: '8px',
    background: color.blackRock,
    color: color.white90,
    fontFamily: '"Inter",sans-serif',
    fontSize: '13px',
    lineHeight: '23px',
    '& fieldset': { borderColor: color.yellow60 },
    '&:hover fieldset': { borderColor: color.lightningYellow },
    '&.Mui-focused fieldset': { borderColor: color.lightningYellow },
    '& .MuiSvgIcon-root': { color: color.white50 }
};

export const modeLabelSx = {
    font: '600 14px/17px "Inter",sans-serif',
    color: color.white90,
    marginBottom: '8px'
};

export const modeMenuItemSx = {
    fontFamily: '"Inter",sans-serif',
    fontSize: '13px',
    color: color.white90,
    '&:hover': { backgroundColor: 'rgba(255,255,255,0.06)' },
    '&.Mui-selected': {
        backgroundColor: 'rgba(255,255,255,0.08)',
        '&:hover': { backgroundColor: 'rgba(255,255,255,0.10)' }
    }
};

export const modeMenuProps = {
    PaperProps: {
        sx: {
            backgroundColor: color.darkGray,
            borderRadius: '8px',
            border: `1px solid ${color.yellow60}`,
            '& .MuiList-root': { padding: '4px' }
        }
    }
};

export const recommendedChipSx = {
    fontFamily: '"Inter",sans-serif',
    fontSize: '11px',
    color: color.lightningYellow,
    marginLeft: '6px',
    fontWeight: 500
};
